<template>
	<div class="container">
		<div class="banner">
			<img src="../../../static/images/seckill/header.png"/>
		</div>
		<!--商品列表-->
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
			<div class="goods-list">
				<div v-for="(item, index) in productList" :key="index" class="main-item">
					<div class="tui-pro-item"  @click="detail(item)">
						<img :src="item.mpUrl" class="tui-pro-img"  mode="widthFix" />
						<div class="tui-pro-content">
							<div class="tui-pro-tit">{{ item.mpName }}</div>
							<div class="tui-pro-price">
								<p class="tui-sale-price">{{ item.grouponPrice }}</p>
								<p class="tui-factory-price">￥{{ item.salePriceScope }}</p>
							</div>
							<div class="tui-pro-pay" @click="purchase">去拼团</div>
						</div>
						<img src="../../../static/images/seckill/left.png" class="left"/>
						<p class="left-title">拼团价</p>
					</div>
				</div>
			</div>
		</van-list>

	</div>
</template>

<script>
import { getGroupThemeList } from "@/api/api";
import notData from "@/components/notData";
export default {
    components: {

    },
	data() {
		return {
			banner:[
				{pictureUrl:'https://i.loli.net/2020/11/19/fBrEqTb4htoPdiR.png'}
			],
			timeList:[
				{time:'00.00',title:'抢购中'},
				{time:'10:00',title:'明日开始'},
				{time:'14:00',title:'明日开始'},
				{time:'20:00',title:'明日开始'},
				{time:'22:00',title:'明日开始'},
			],
			timeIndex:1,
			productList: [],
			loading: false, // 是否加载完成
			finished: true, // 是否加载完成
			list: [], //数据
			limit: 10, // 每次请求条数
			start: 1, // 开始页数
		};
	},
	mounted: function(options) {
		if (this.$route.query.token) {
			this.$cookies.set('token', this.$route.query.token);
		}
		this.onLoad();
	},
	methods: {
		// list 组件请求数据
		onLoad() {
			this.getList();
		},
		// 请求数据
		async getList() {
			let sendData = {
				// type: 1,
				start: this.start,
				limit: this.limit
			};
			const res = await getGroupThemeList(sendData);
			if (res.code == "0000") {
				this.productList = this.productList.concat(res.data.rows);
				this.isRequestFinished = true;
				if (res.data.rows.length < this.limit) {
					this.finished = true;
				}
				this.start += 1;
				this.loading = false;
			} else {
				this.$toast(res.msg);
			}
		},
		navClick(e){
			this.timeIndex=e;
		},
		detail(item) {
			this.$router.push({
				path: "/productDetailGroup",
				query:{
					id:item.mpId,
					promotionId:item.groupCode
				}
			});
			location.reload();
		},
	}
};
</script>

<style lang="scss" scoped>
.container {
	background-color:#f1f1f1 ;
}
.banner{
	z-index: 0;
	width: 750px;
	height: 334px;
	img{
		z-index: 0;
		width:100%;
		height: 334px;
	}
}
/* 商品列表*/
.main-item{
	position: relative;
	width: 750px;
}
.left{
	width: 176px;
	height: 83px;
	position: absolute;
	top: -20px;
	left: 15px;
}
.left-title{
	font-size: 38px;
	color: #ffffff;
	position: absolute;
	top: -20px;
	left: 30px;
}
.goods-list{
	background: #f4f4f4;
	border-radius: 50px;
	position: absolute;
	top: 300px;
	z-index: 99999;
	width: 100%;
	padding: 60px 0;
}

.tui-pro-item {
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	padding: 20px 30px;
	background: #ffffff;
	border: 5px solid #f6f6f6;
	box-shadow: 3px 15px 12px 0px rgba(0,11,15,0.36);
	margin-bottom: 45px;
	margin-left: 35px;
	margin-right: 20px;
}

.tui-pro-img {
	width: 180px;
	height: 180px;
	border-radius: 5px;
	display: block;
}

.tui-pro-content {
	display: flex;
	flex-direction: column;
	/*justify-content: space-between;*/
	box-sizing: border-box;
	margin-left: 18px;
	width: 100%;
}

.tui-pro-tit {
	color: #3e3a39;
	font-size: 25px;
	font-weight: 500;
	word-break: break-all;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	height: 70px;
}

.tui-pro-price {
	display: flex;
	align-items: center;
}

.tui-sale-price {
	font-size: 50px;
	font-family: Arial Bold, Arial Bold-Bold;
	font-weight: 700;
	font-style: italic;
	background: linear-gradient(#ff3434 0%, #c00707 100%);
	-webkit-background-clip: text;
	color: transparent;
}

.tui-factory-price {
	font-size: 24px;
	color: #727171;
	text-decoration: line-through;
	padding-left: 12px;
	padding-bottom: 5px;
}

.tui-pro-pay {
	width: 109px;
	height: 40px;
	background: linear-gradient(#ff3434 0%, #c00707 100%);
	border-radius: 20px;
	font-size: 24px;
	font-weight: 600;
	text-align: center;
	color: #ffffff;
	line-height: 40px;
}
/* 商品列表*/
</style>
